query TAStatusChartData {
  kpiTaStatuses(orderBy: ID_ASC) {
    nodes {
      title
      amount
      searchHint
    }
  }
}
